function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54 58C53.4696 58 52.9609 58.2107 52.5858 58.5858C52.2107 58.9609 52 59.4696 52 60C52 60.5304 52.2107 61.0391 52.5858 61.4142C52.9609 61.7893 53.4696 62 54 62C54.5304 62 55.0391 61.7893 55.4142 61.4142C55.7893 61.0391 56 60.5304 56 60C56 59.4696 55.7893 58.9609 55.4142 58.5858C55.0391 58.2107 54.5304 58 54 58ZM54 68C53.4696 68 52.9609 68.2107 52.5858 68.5858C52.2107 68.9609 52 69.4696 52 70C52 70.5304 52.2107 71.0391 52.5858 71.4142C52.9609 71.7893 53.4696 72 54 72C54.5304 72 55.0391 71.7893 55.4142 71.4142C55.7893 71.0391 56 70.5304 56 70C56 69.4696 55.7893 68.9609 55.4142 68.5858C55.0391 68.2107 54.5304 68 54 68ZM54 78C53.4696 78 52.9609 78.2107 52.5858 78.5858C52.2107 78.9609 52 79.4696 52 80C52 80.5304 52.2107 81.0391 52.5858 81.4142C52.9609 81.7893 53.4696 82 54 82C54.5304 82 55.0391 81.7893 55.4142 81.4142C55.7893 81.0391 56 80.5304 56 80C56 79.4696 55.7893 78.9609 55.4142 78.5858C55.0391 78.2107 54.5304 78 54 78Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40 10H60L77.0574 16.2027C80.1515 17.3278 82.4936 19.9039 83.3199 23.091L96 72L82 76L74 48V90H46",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M54 90H26V48L18 76L4 72L16.6801 23.091C17.5064 19.9039 19.8485 17.3278 22.9427 16.2027L40 10H60",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M60 10L49.106 44.5C48.372 46.82 48 49.238 48 51.67V90",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M40 10L50 40M48 52L66 24L64 20L68 14M48 48L34 24L36 20L32 14",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgSuit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuit);
export default __webpack_public_path__ + "static/media/suit.283344ae.svg";
export { ForwardRef as ReactComponent };